module.exports = __webpack_public_path__ + "static/media/backButton.c7025613.png";